import {CommonModule} from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import {RouterModule} from '@angular/router';
import {LetDirective} from '@ngrx/component';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CommonComponentsModule} from '../common/components/common-components.module';
import {AddressApiService} from '../data/api/service';
import {SeFeComponentsModule} from '../se-fe-components.module';
import {AddressEffects} from './address.effects';
import {addressFeatureKey, reducer as addressReducer} from './address.reducer';
import {ShippingFormComponent} from './components/shipping-form/shipping-form.component';
import {SuggestedAddressComponent} from './components/suggested-address/suggested-address.component';

@NgModule({
  declarations: [ShippingFormComponent, SuggestedAddressComponent],
  exports: [ShippingFormComponent, SuggestedAddressComponent],
  imports: [
    CommonModule,
    CommonComponentsModule,
    EffectsModule.forFeature([AddressEffects]),
    FormsModule,
    LetDirective,
    MatRadioModule,
    ReactiveFormsModule,
    RouterModule,
    StoreModule.forFeature(addressFeatureKey, addressReducer),
    SeFeComponentsModule,
  ],
  providers: [
    AddressApiService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class TaxAndShippingModule {}
